import { css } from 'styled-components';

import { ICheckboxContain } from './common';

export const CheckboxBackgroundStyles = css<ICheckboxContain>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 1.75em;
  height: 1.75em;
  border-radius: ${({ theme: { input }}) => input.borderRadius};
  background: ${({ theme: { checkbox }, alert }) => alert ? checkbox.colorBackgroundAlert : checkbox.colorBackground};
`;
